<div class="gcontainer report-preview-wrapper">
  <div class="row">
    <div class="col-md-11">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page">
            <a class="c-primary" [routerLink]="'/dashboard'" tabindex="0"> Dashboard </a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Report - Precast
          </li>
        </ol>
      </nav>
    </div>
    <div class="col-md-1">
      <button class="refresh" mat-raised-button (click)="refresh()" >
        Refresh
      </button>
    </div>
  </div>
  <mat-card class="bsmokewhite">
    <mat-card-content>
      <div class="row">
        <div class="col-md-1 worksheet-header-column-first">
          <h1 class="mat-h1">Pre Cast</h1>
        </div>
        <div class="col-md-1 worksheet-header-column-middle">
          <div class="pr-32">
            @if (worksheetRecords) {
              <span
                class="mat-header-data"
                >
                {{ worksheetRecords.project.referenceId }}
              </span>
            }
          </div>
          <mat-label class="mat-header-subtitle">Reference</mat-label>
        </div>
        <div class="col-md-2 worksheet-header-column-middle">
          <div class="pr-32">
            @if (worksheetRecords) {
              <span
                class="mat-header-data word-break-anyware"
                >
                {{ worksheetRecords.company.name || '-' }}
              </span>
            }
          </div>
          <mat-label class="mat-header-subtitle">Customer</mat-label>
        </div>
        <div class="col-md-3 worksheet-header-column-middle">
          <div class="pr-32">
            @if (worksheetRecords) {
              <span
                class="mat-header-data word-break-anyware"
                >
                {{ worksheetRecords.project.projectName }}
              </span>
            }
          </div>
          <mat-label class="mat-header-subtitle">Project Name</mat-label>
        </div>
        <div class="col-md-1 worksheet-header-column-middle">
          <div class="pr-32">
            @if (worksheetRecords) {
              <span
                class="mat-header-data word-break-anyware"
                >
                {{ worksheetRecords.project.projectNumber || '-' }}
              </span>
            }
          </div>
          <mat-label class="mat-header-subtitle">Project Number</mat-label>
        </div>
        <div class="col-md-1 worksheet-header-column-middle">
          <div class="pr-32">
            @if (worksheetRecords) {
              <span
                class="mat-header-data"
                >
                {{ worksheetRecords.project.storageCompartment || '-' }}
              </span>
            }
          </div>
          <mat-label class="mat-header-subtitle">Storage Location</mat-label>
        </div>
        <div class="col-md-1 worksheet-header-column-middle">
          <div class="pr-32">
            @if (worksheetRecords) {
              <span
                class="mat-header-data"
                >
                {{ worksheetRecords.project.sampleReceivedDate
                ? (worksheetRecords.project.sampleReceivedDate | utcToLocal:'date')
                : '-' }}
              </span>
            }
          </div>
          <mat-label class="mat-header-subtitle">Samples Received</mat-label>
        </div>
        <div class="col-md-1 worksheet-header-column-last">
          <div class="pr-32">
            @if (worksheetRecords) {
              <span
                class="mat-header-data"
                >
                {{ worksheetRecords.project.dueDate
                ? (worksheetRecords.project.dueDate | utcToLocal:'date')
                : '-' }}
              </span>
            }
          </div>
          <mat-label class="mat-header-subtitle">Due Date</mat-label>
        </div>
        <div class="col-md-1 d-flex justify-content-end">
          <div class="days-badge" [ngClass]="{ 'danger': daysLeft < 10, 'normal': daysLeft >= 10 }">
            <span class="days-value">
              {{ daysLeft }}
            </span>
            <span class="days-label">Days</span>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <div class="report-header">
    <div class="head">
      <h1>Thermal Resistivity Report</h1>
    </div>
    <div class="banner-wrapper">
      <div class="r-l">
        <span class="st c-primary">{{ statusLabel }}</span>
      </div>
      @if (!userService.roleCheck(['Accounting'])) {
        <div class="r-r">
          <app-customer-attachments
            [projectId]="projectId"
            [backgroundClass]="'yellow'"
            [showSuccess]="false"
          style="vertical-align: middle; margin-right: 16px"></app-customer-attachments>
          <button class="c-primary" (click)="openViewSubmissionForm()">
            <img src="assets/icons/File.svg" alt="" />View Submission Form
          </button>
          <button class="c-primary" (click)="openWorksheet()">
            <img src="assets/icons/File.svg" alt="" />View Worksheet
          </button>
          <button class="c-primary" (click)="printCover()">
            <img src="assets/icons/print-gray.svg" alt="" />Print Cover
          </button>
          <button class="c-primary" (click)="openAssignToDialog()">
            <img src="assets/icons/people.svg" alt="" />Assign
          </button>
          <button class="c-primary" (click)="openSetStatusDialog()">
            <img src="assets/icons/Done.svg" alt="" />Set Status
          </button>
        </div>
      }
      <div class="clearfix">
        <mat-divider></mat-divider>
        <div class="assignto"><span >Assigned To: {{ reportOwner }}</span></div>

        <div class="reviewby"> <span>Review By: {{ firstReviewerName }}
          @if (secondReviewerName) {
            <span>, {{ secondReviewerName }}</span>
          }
        </span></div>
      </div>
    </div>
    <div
      class="r-tab-wrapper">
      <mat-tab-group
        #tabGroup
        animationDuration="0"
        [(selectedIndex)]="selectedIndex">
        @if (!userService.roleCheck(['Accounting'])) {
          <mat-tab label="EDIT">
            <app-edit-precast-report
              [projectId]="projectId"
              [projectReference]="projectReference ?? ''"
            [preApproval]="preapproval ?? false"></app-edit-precast-report>
          </mat-tab>
        }
      </mat-tab-group>

    </div>
  </div>
</div>
